import * as yup from "yup";

export const addVersionValidator = yup.object({
  version: yup
    .string()
    .matches(/^\d+(\.\d+){2,3}$/, "Use only digits in format x.xx.xx[.xx]")
    .required("Field is required"),
  description: yup.string(),
});

export const addIUVersionValidator = yup.object({
  version: yup
    .string()
    .matches(/^\d{1,2}\.\d{1,2}$/, "Use only digits in format xx.xx")
    .required("Field is required"),
});
